import { CSSProperties, FC, ReactNode } from "react";
import { useContainerStyles } from "./Container.styles";
import { mergeClasses } from "@fluentui/react-components";

interface IContainer {
  children: ReactNode;
  style?: CSSProperties;
  className?: string;
  ariaLabel?: string;
}

const Container: FC<IContainer> = ({
  children,
  className,
  style,
  ariaLabel,
}) => {
  const classes = useContainerStyles();

  return (
    <div
      className={mergeClasses(classes.container, className)}
      style={{ ...style }}
      aria-label={ariaLabel}
    >
      {children}
    </div>
  );
};

export default Container;
